export default __webpack_public_path__ + "static/media/new-window.94e4b6f1.svg";